module.exports = __webpack_public_path__ + "img/4-4.d90d84ef.svg";